import { URLS } from '@constants'
import { GETAllSystem } from '@types'

import { commonAPI } from './common.api'

export const systemAPI = commonAPI.injectEndpoints({
  endpoints: build => ({
    fetchAllSystem: build.query<GETAllSystem, void>({
      query: () => ({
        url: URLS.CORE_API + `/models/system/list`,
      }),
    }),
  }),
})

export const { useFetchAllSystemQuery } = systemAPI
